/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useUpdateDocumentChunk } from 'core/hooks/api'

// Styled Elements
import {
  TableButtonWrapper,
  TableRowWrapper,
  TableRowContainer,
  TableText,
  TablePanelWrapper,
} from './AiDocumentChunkTableItem.elements'

// Views
import { AccordionTableItem, TextArea, JsonField, Button } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function AiDocumentChunkTableItem(props) {
  // Destructure
  const { data } = props

  // States
  const [isExpanded, setIsExpanded] = useState(false)

  // Hooks
  const {
    updateDocumentChunk,
    updateDocumentChunkData,
    updateDocumentChunkError,
    isUpdateDocumentChunkLoading,
  } = useUpdateDocumentChunk()

  // Component States
  const [content, setContent] = useState()
  const [metadata, setMetadata] = useState()
  const [disabled, setDisabled] = useState(true)

  // Functions
  const handleUpdate = () => {
    let payload = { id: data.id, document_id: data.document_id }
    if (content !== data.content) payload = { ...payload, content }
    if (metadata !== data.chunk_metadata) payload = { ...payload, chunk_metadata: metadata }
    updateDocumentChunk(payload)
  }

  // UseEffects
  useEffect(() => {
    setContent(data?.content)
    setMetadata(data?.chunk_metadata)
  }, [data])
  useEffect(() => {
    if (updateDocumentChunkData && !updateDocumentChunkError && !isUpdateDocumentChunkLoading) window.location.reload()
  }, [updateDocumentChunkData])
  return (
    <AccordionTableItem
      setIsExpanded={(val) => {
        setIsExpanded(val)
      }}
      expandPanel={isExpanded}
      button={
        <TableButtonWrapper>
          <TableRowWrapper>
            <TableRowContainer>
              <TableText>{`${data?.content?.slice(0, 150)}...`}</TableText>
            </TableRowContainer>
          </TableRowWrapper>
        </TableButtonWrapper>
      }
      panel={
        <TablePanelWrapper>
          <TextArea
            rows="8"
            label="Content"
            value={content}
            onChange={(e) => {
              console.log(e.target.value)
              setContent(e.target.value)
            }}
            disabled={disabled}
          />
          <JsonField rows="8" label="Metadata" initialValue={metadata} onChange={setMetadata} disabled={disabled} />
          <TableRowWrapper style={{ justifyContent: 'flex-end', paddingTop: '20px' }}>
            {disabled && !isUpdateDocumentChunkLoading &&
            <Button onClick={() => setDisabled(false)}>Edit</Button>
          }
            {!disabled && !isUpdateDocumentChunkLoading &&
            <TableRowContainer style={{ justifyContent: 'flex-end' }}>
              <Button onClick={() => setDisabled(true)} variant="outlined">Cancel</Button>
              <Button onClick={() => handleUpdate()}>Save</Button>
            </TableRowContainer>
            }
            {isUpdateDocumentChunkLoading && <Button disabled>Loading...</Button>}
          </TableRowWrapper>
        </TablePanelWrapper>
      }
    />
  )
}

// Default Props
AiDocumentChunkTableItem.defaultProps = {
  data: {
    id: '',
    document_id: '',
    content: '',
    embedding: '',
    chunk_metadata: '',
  },
}

// Proptypes Validation
AiDocumentChunkTableItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    document_id: PropTypes.string,
    content: PropTypes.string,
    embedding: PropTypes.string,
    chunk_metadata: PropTypes.string,
  }),
}
export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentChunkTableItem)
